export const checkLastFiveMessages = (array) => {
  if (array.length < 5) {
    return false; // Less than five messages
  }

  const lastFive = array.slice(-5);

  const firstSender = lastFive[0].sender;

  // Check if all senders in the last five messages are the same
  for (let i = 1; i < lastFive.length; i++) {
    if (lastFive[i].sender !== firstSender) {
      return false; 
    }
  }

  if (firstSender === "CUSTOMER") {
    return "not more than five message";
  }
};

